import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function PelvicHealthHero() {
  return <section id="pelvic-health-hero" className="relative flex min-h-[80vh] w-full flex-col items-center justify-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/woman_stretching_studio.png)] bg-cover bg-center bg-no-repeat">
      <div className="absolute inset-0 bg-primary/50 mix-blend-multiply" />
      <div className="absolute inset-0 bg-dark-section/30" />

      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center justify-center px-4 py-20 text-center sm:px-6 lg:px-8">
        <h1 className="mb-6 font-display text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl md:text-6xl">
          Pelvic Health Physiotherapy in Doncaster
        </h1>

        <p className="mb-10 max-w-2xl text-lg font-medium leading-relaxed text-white/90 sm:text-xl">
          Expert, compassionate care to help you restore core strength, overcome discomfort, and return to the activities you love with confidence.
        </p>

        <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
          <Button size="lg" className="h-auto rounded-full bg-primary px-8 py-4 text-lg font-bold text-primary-foreground shadow-strong transition-all duration-300 hover:scale-105 hover:bg-primary-hover hover:shadow-strong">
            Book Your Appointment
          </Button>
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="size-8 text-white/70" aria-hidden="true" />
      </div>
    </section>;
}